import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { sustentosModulo } from '../../diccionarios/sustentosModulo';
import { AngenciasModel } from '../../models/agenciasModel';
import { ClaveValorModel } from '../../models/claveValorModel';
import { DocumentoModel } from '../../models/documentoModel';
import { RetencionModel } from '../../models/retencionModel';
import { ImagenSustentoPagoModel } from '../../models/imagenSustentoPagoModel';
import { ResposeDocumentoModel } from '../../models/responseDocumentoMode';
import { ResponseRetencionModel } from '../../models/responseRetencionModel';
import { ResponseTreeAfectModel } from '../../models/responseTreeAfectModel';
import { ResponseTreeNodeModel } from '../../models/responseTreeNodeModel';
import { SelectedGridModel } from '../../models/selectedGridModel';
import { SelectedGridRetencionModel } from '../../models/selectGridRetencionModel';
import { TreeDocDetModel } from '../../models/treeDocDetModel';
import { CatalogoService } from '../../services/catalogo.service';
import { FacturaService } from '../../services/factura.service'; 
import { RetencionService } from '../../services/retencion.service';
import { DatosMaestrosService } from 'src/app/services/datos-maestros.service';
import { UtilsService } from 'src/app/shared/utils/utils.service';
import { LfsaBotonEditarGridComponent } from 'src/app/shared/components/lfsa-boton-editar-grid/lfsa-boton-editar-grid.component';

@Component({
  selector: 'app-retenciones',
  templateUrl: './retenciones.component.html',
  styleUrls: ['./retenciones.component.css']
})
export class RetencionesComponent implements OnInit {

  @ViewChild('fileInput') fileInput: ElementRef;
  columnDefs: any[];//aggrid
  rowData: ResponseRetencionModel[] = [];

  frameworkComponents: any;
  gridApi: any;
  gridColumnApi: any;
  rowSelection: any;
  sustentosModulo: any = {};

  listaVacia: boolean = true;
  loading: boolean = false;

  cmbPeriodo: ClaveValorModel[] = [];
  cmbAnio: ClaveValorModel[] = [];
  cmbOfiVentas: any[] = [];
  cmbContenedor: any[] = [];
  cmbEmpresas: any[] = [];
  cmbOpciones: any[] = [];
  cmbOpcionesRetencion: any[] = [];
  cmbStatusDocumentos: any[] = [];

  value: string;
  formulario: FormGroup;//formulario
  formOptions: FormGroup;
  formSustento: FormGroup;
  selectedAnios: any[] = [];
  selectedPeridos: any[] = [];
  selectedAgencias: any[] = [];
  selectedEmpresas: any[] = [];
  clienteIcon: string;
  fechaCalendarioIcon: string;
  empresaIcon: string;
  agenciaIcon: string;
  periodoIcon: string;
  fechaRegIcon: string;
  checkOptionIcon: string;

  resposiveFull: string;

  objSelected: SelectedGridRetencionModel = null;
  pdfB64: any;
  dataTree: any[] = [];
  dataTreeAfect: any[] = [];
  
  objTreeAfect: ResponseTreeAfectModel;
  objTreeNode: ResponseTreeNodeModel;
  loader: boolean = false;
  loaderTabs: boolean = false;
  loaderModal: boolean = false;

  constructor(private fb: FormBuilder,
    public sanitizer: DomSanitizer,
    private _global: DatosMaestrosService,
    private _catalogo: CatalogoService,
    private _factura: FacturaService,
    private _retencion: RetencionService,
    private _util: UtilsService) { }

  ngOnInit() {
    setTimeout(()=>{
      this.cmbPeriodo = this._catalogo.getPeriodo();
    },200);
    this.cmbOpciones = this._catalogo.getCatalogoOpcionesStatusReteciones();
    this.cmbOpcionesRetencion = this._catalogo.getCatalogoOpcionesRetencion();
    this.cmbStatusDocumentos = this._catalogo.getCatalogoStatusReteciones();
    this.getAnios();
    this.getOficinasVentas();
    this.getAllEmpresas();
    this.cargarIconos();
    this.sustentosModulo = sustentosModulo;
    this.resposiveFull = this.sustentosModulo.div.resposiveFull;

    this.formulario = this.fb.group({
      retencionEmisor: [''],// [Validators.required]],
      rucEmisor:[''],
      numFacturaFabril: [''],// [Validators.required]],
      cliente: [''],// [Validators.required]],
      fechaRegIni:[''],
      fechaRegFin:[''],
      rucCliente:[''],
      reservado: ['Todos'], //[Validators.required]],
      sustentado: ['Todos'], //[Validators.required]],
      statuDocumento:[''], //[Validators.required]]
    });
    this.formOptions = this.fb.group({
      statusSustento: ['', [Validators.required]]
    });
    this.formSustento = this.fb.group({
      multipart: ['', [Validators.required]],
    });
    this.formulario.get('reservado').setValue('Todos');
    this.formulario.get('sustentado').setValue('Todos');
    this.cargarGrid();
  }

  cargarGrid() {
    this.columnDefs = [
      {
        headerName: 'AGENCIA',
        field: 'id_agencia',
        filter: true,
        width: 150,
      },
      {
        headerName: 'AÑO',
        field: 'anio',
        sortable: true,
        width: 150,
        filter: true
      },
      {
        headerName: 'PERIODO',
        field: 'periodo',
        sortable: true,
        filter: true,
        width: 150,
      },
      {
        headerName: 'RUC',
        field: 'cliente.rucCliente',
        sortable: true,
        filter: true,
        width: 200,
      },
      {
        headerName: 'CLIENTE',
        field: 'cliente.nombreCliente1',
        sortable: true,
        filter: true,
        width: 300,
      },
      {
        headerName: 'BASE IMPONIBLE',
        field: 'baseimponible',
        sortable: true,
        filter: true,
        width: 200,
      },
      {
        headerName: '% RET.',
        fiel: 'porcentaje',
        sortable: true,
        filter: true,
        width: 200,
      },
      {
        headerName: 'VALOR',
        field: 'monto',
        sortable: true,
        filter: true,
        width: 200,
      },
      {
        headerName: 'NUM. FACTURA',
        field: 'numFactura',
        sortable: true,
        filter: true,
        width: 200,
      },
      {
        headerName: 'NUM. RETENCIÓN.',
        field: 'numRetencion',
        sortable: true,
        filter: true,
        width: 200,
      },
      {
        headerName: 'AUTORIZACIÓN.',
        field: 'numAutorizacion',
        sortable: true,
        filter: true,
        width: 350,
      },
      {
        headerName: 'TIPO RET.',
        field: 'retencionPK.tretString',
        sortable: true,
        filter: true,
        width: 200,
      },
      {
        headerName: 'DOC. ELECTRONICO.',
        field: 'docElectronicoString',
        sortable: true,
        filter: true,
        width: 200,
      },
      {
        headerName: 'TIPO FACT.',
        field: 'retencionPK.ttyp',
        sortable: true,
        filter: true,
        width: 200,
      },
      {
        headerName: 'NUM. FACT.',
        field: 'retencionPK.ninv',
        sortable: true,
        filter: true,
        width: 200,
      },
      {
        headerName: 'FECHA REGISTRO',
        field: 'fechaRegistro',
        sortable: true,
        filter: true,
        width: 200,
      },
      {
        headerName: 'DOCUMENTO',
        field: 'retencionPK.ttyp_r',
        sortable: true,
        filter: true,
        width: 200,
      },
      {
        headerName: 'COD. RET.',
        field: 'retencionPK.cret',
        sortable: true,
        filter: true,
        width: 200,
      },
      {
        headerName: 'SUSTENTADO',
        field: 'numSustento',
        sortable: true,
        filter: true,
        width: 200,
      }
    ];

    this.frameworkComponents = {
      buttonRenderer: LfsaBotonEditarGridComponent,
    };

    this.rowSelection = 'multiple';
  }

  cargarIconos() {
    this.clienteIcon = this._catalogo.catalogoIcon().cliente;
    this.fechaCalendarioIcon = this._catalogo.catalogoIcon().calendario;
    this.empresaIcon = this._catalogo.catalogoIcon().empresa;
    this.agenciaIcon = this._catalogo.catalogoIcon().agencia;
    this.periodoIcon = this._catalogo.catalogoIcon().periodo;
    this.fechaRegIcon = this._catalogo.catalogoIcon().fechaReg;
    this.checkOptionIcon = this._catalogo.catalogoIcon().checkOption;
  }

  onQuickFilterChanged() {
    this.gridApi.setQuickFilter(this.formulario.get('buscar').value);
  }

  onGridReady(params) {
    this.gridApi = params.api;
    this.gridColumnApi = params.columnApi;
  }

  getAnios() {
    this._factura.getAnios().subscribe((res: ClaveValorModel[]) => {
      this.cmbAnio = res;
    }, (err) => {
      this.cmbAnio = [];
      this._util.mensajeErrorVisto(err.error.mensaje);
    });
  }

  getOficinasVentas() {
    this._global.getAllOficinasVentas().subscribe((res: AngenciasModel[]) => {
      this.cmbOfiVentas = res;
      this.cmbOfiVentas.map((e: AngenciasModel) => {
        e['cadena'] = e.idOficinaVenta + '-' + e.dscaOficinaVenta
      });
    }, (err) => {
      this.cmbOfiVentas = [];
      this._util.mensajeErrorVisto(err.error.mensaje);
    });
  }

  getAllEmpresas() {
    this._global.getAllEmpresas().subscribe((res: any) => {
      this.cmbEmpresas = res;
    }, (err) => {
      this.cmbEmpresas = [];
      this._util.mensajeErrorVisto(err.error.mensaje);
    });
  }

  obtenerAnios(anios) {
    this.selectedAnios = anios;
    this.selectedAnios = this.getValueArray(this.selectedAnios);
    console.log(this.selectedAnios);
  }

  obtenerPeriodo(periodos) {
    this.selectedPeridos = periodos;
    this.selectedPeridos = this.getValueArray(this.selectedPeridos);
    console.log(this.selectedPeridos);
  }

  obtenerAngencias(agencias) {
    this.selectedAgencias = agencias;
    this.selectedAgencias = this.getValueArray(this.selectedAgencias, 'idOficinaVenta');
    console.log(this.selectedAgencias);
  }

  obtenerEmpresas(empresas) {
    this.selectedEmpresas = empresas;
    this.selectedEmpresas = this.getValueArray(this.selectedEmpresas, 'idEmpresa');
    console.log(this.selectedEmpresas);
  }

  devolverObjeto(data): RetencionModel {
    const enviarObjeto = new RetencionModel(data);
    return enviarObjeto;
  }

  getValueArray(data, clave?) {
    let key = (clave) ? clave : 'clave';
    let respuesta: any[] = [];
    for (let i = 0; i < data.length; i++) {
      const el = data[i];
      respuesta.push(el[key]);
    }
    return respuesta;
  }

  buscarRetencion() {
    this.formulario.get('retencionEmisor').setValue('');
    this.formulario.get('rucEmisor').setValue('');
    this.formulario.get('numFacturaFabril').setValue('');
    let data = this.formulario.value;
    data.cliente = this.formulario.get('cliente').value;
    data.anios = this.selectedAnios;
    data.meses = this.selectedPeridos;
    data.oficinas = this.selectedAgencias;
    data.empresas = this.selectedEmpresas;
    data.reservado = this.formulario.get('reservado').value;
    data.sustentado = this.formulario.get('sustentado').value;
    data.statuDocumento = this.formulario.get('statuDocumento').value;
    this.buscarRetencionServices(data);
  }

  buscarRetencionEmisor() {
    this.formulario.get('cliente').setValue('');
    this.formulario.get('numFacturaFabril').setValue('');
    let data = this.formulario.value;
    data.retencionEmisor = this.formulario.get('retencionEmisor').value;
    data.rucEmisor = this.formulario.get('rucEmisor').value;
    this.buscarRetencionServices(data);
  }

  buscarRetencionNumFac() {
    this.formulario.get('cliente').setValue('');
    this.formulario.get('retencionEmisor').setValue('');
    this.formulario.get('rucEmisor').setValue('');
    let data = this.formulario.value;
    data.numFacturaFabril = this.formulario.get('numFacturaFabril').value;
    this.buscarRetencionServices(data);
  }

  buscarRetencionServices(data) {
    this.loading = true;
    // debugger;
    this._retencion.getRetencion(this.devolverObjeto(data)).subscribe((res: ResponseRetencionModel[]) => {
      this.loading = false;
      this.listaVacia = false;
      this.rowData = res;
    }, (err) => {
      this.loading = false;
      this.listaVacia = true;
      this._util.mensajeErrorVisto(err.error.mensaje);
    });
  }

  rowClickData(data) {
    this.loaderTabs = true;
    let documento: ResponseRetencionModel = data.data;
    this._retencion.postRetencion(documento).subscribe((res: SelectedGridRetencionModel) => {
      this.loaderTabs = false;
      this.objSelected = res;
      this.pdfB64 = this.sanitizer.bypassSecurityTrustResourceUrl('data:application/pdf;base64,' + this.objSelected.sustentoFactura);
    }, (err) => {
      console.log(err);
      this.objSelected = null;
      this.loaderTabs = false;
    });
  }

  callModalOption(target) {
    document.getElementById('abrirModalOpciones').click();
  }

  callModalSustento(target) {
    document.getElementById('abrirModalSustento').click();
  }

  editStatusSustento() {
    let statusSustento = this.formOptions.get('statusSustento').value;
    this._util.confirmarSincronoPromesaNormal(
      {
        title: 'Esta seguro que desea guardar los siguientes datos?',
        text: '',
        action: 'Guardar',
        funcion: this._retencion.updateStatusDoc(this.objSelected.sustentoxDocumentoSelected, statusSustento),
        loading: true,
        context: this,
      }
    ).then((res: any) => { 
      console.log(res);
      this.formOptions.reset(); 
      document.getElementById('cerrarModalOpciones').click();
      this.objSelected = null;
    }).catch((err) => { console.log('Error ' + err); });
  }

  action(item) {
    item.open = !item.open;
  }

  callActionDocumntoAfect(item) {
    // item.pkValue = {
    //   "docn": 0,
    //   "line": 0,
    //   "lino": 0,
    //   "ninv": 1400000015,
    //   "tdoc": " ",
    //   "ttyp": "ZF"
    // }
    // item.name = 'ZF-1400000015-0';
    this.loader = true;
    this._factura.postDocumentTreeAfec(item.pkValue, item.name).subscribe((res: ResponseTreeAfectModel) => {
      console.log(res);
      this.objTreeAfect = res;
      this.loader = false;
    }, (err) => {
      console.log(err);
      this.objTreeAfect = null;
      this.loader = false;
    });
  }

  callActionDocumento(item) {
    // item.pkValue = {
    //   "docn": 0,
    //   "line": 0,
    //   "lino": 0,
    //   "ninv": 1400000015,
    //   "tdoc": " ",
    //   "ttyp": "ZF"
    // }
    // item.name = 'ZF-1400000015-0';
    this.loader = true;
    this._factura.postDocumentTreeNode(item.pkValue, item.name).subscribe((res: ResponseTreeNodeModel) => {
      console.log(res);
      this.objTreeNode = res;
      this.loader = false;
    }, (err) => {
      console.log(err);
      this.objTreeNode = null;
      this.loader = false;
    });
  }

  //multipart
  onFileSelect(event) {
    // let allowedExtensions = /(.csv)$/i;
    var allowedExtensions = /(\.jpg|\.jpeg|\.png|\.gif|\.pdf)$/i;
    if (event.target.files.length > 0) {
      const file = event.target.files[0];
      if (!allowedExtensions.exec(file.name)) {
        this.formSustento.get('multipart').setValue('');
        this._util.mensajeErrorVisto('El tipo de archivo no es valido, los tipo de archivo permitido son |jpg |jpeg |png |gif |pdf  ', true, 10000);
        this.fileInput.nativeElement.value = '';
      } else {
        this.formSustento.get('multipart').setValue(file);
      }
    }
  }

  setFormData() {
    let data = {
      cliente: this.objSelected.cliente,
      listImagenSustentoPago: this.objSelected.listImagenSustentoPago,
      lstSustentoDoc: this.objSelected.lstSustentoDoc,
      retencionPK: this.objSelected.retencionPK,
    }
    let objecto = {
      data: JSON.stringify(data),
      file: this.formSustento.get('multipart').value,
    };
    const formData = new FormData();
    Object.keys(objecto).forEach(key => formData.append(key, objecto[key]));
    return formData;
  }

  uploadSustento() {
    this._util.confirmarSincronoPromesaNormal(
      {
        title: 'Esta seguro que desea subir el siguientes sustento?',
        text: '',
        action: 'Upload',
        funcion: this._retencion.uploadSustento(this.setFormData(), true),
        loading: true,
        context: this,
      }
    ).then((res: any) => { 
      console.log(res);
      this.formOptions.reset(); 
      document.getElementById('cerrarModalSustentos').click();
      this.objSelected = null;
      this.fileInput.nativeElement.value = '';
     }).catch((err) => { console.log('Error ' + err); });
  }

}
